import useSeo from '@/hooks/useSeo';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import LatestWorks from '@/pages/home/components/LatestWorks';
import LatestNews from '@/pages/home/components/LatestNews';
import SiteIntro from '@/pages/home/components/SiteIntro';

export default function Home() {
  useSeo({
    title: '吉泽明步影视明星资料与作品介绍',
    description:
      '吉泽明步官方网站，提供全面的影视明星资料和作品介绍，涵盖最新影视动态和人物信息，满足影迷多样化需求。',
    keywords: '吉泽明步,影视明星,作品介绍,影视资料,明星动态,影视信息,演员吉泽明步',
  });

  return (
    <>
      <h1 className="sr-only">吉泽明步影视明星资料与作品介绍</h1>
      <HeroCarousel />
      <CategoryEntries />
      <LatestWorks />
      <LatestNews />
      <SiteIntro />
    </>
  );
}